export default __webpack_public_path__ + "static/piscina-termica-52f7dd50de821629c1a52e99cfa23888.jpg";